import { inject, Injectable } from '@angular/core';
import {
  AppConfigService,
  ApplicationConfig,
  CommonService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { ICorporatePartner } from '../../models/corporate-partner/corporate-partner.interface';
import { getCorporatePartner } from './corporate-partner.method';

@Injectable({
  providedIn: 'root'
})
export class CorporateMethodsService {
  config = inject(AppConfigService);
  common = inject(CommonService);
  appConfig = inject(ApplicationConfig);

  getCorpPartner(
    partnerId: string,
    corpPartner: ICorporatePartner,
    cacheKeySuffix: string
  ): ICorporatePartner {
    const vendor: string = this.common.getDeepLinkVendorValue(cacheKeySuffix);

    const defaultOrPersonal: boolean = this.isDefaultOrPersonal(partnerId);

    return vendor && defaultOrPersonal
      ? getCorporatePartner(vendor)
      : corpPartner;
  }

  isDefaultOrPersonal(partnerId: string): boolean {
    return partnerId === 'default' || partnerId === 'personal';
  }
}
